export function formatTime(type) {
  var date = new Date(new Date().getTime());
  var YY = date.getFullYear() + "-";
  var MM =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var hh =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var mm = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var ss =
    ":" +
    (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
  if (type == 1) {
    return YY + MM + DD;
  } else if (type == 2) {
    return YY + MM + DD + " " + hh + mm;
  } else {
    return YY + MM + DD + " " + hh + mm + ss;
  }
}

// base64图片转file的方法（base64图片, 设置生成file的文件名）
export function base64ToFile(base64, fileName) {
  // 将base64按照 , 进行分割 将前缀  与后续内容分隔开
  const data = base64.split(",");
  // 利用正则表达式 从前缀中获取图片的类型信息（image/png、image/jpeg、image/webp等）
  const type = data[0].match(/:(.*?);/)[1];
  // 从图片的类型信息中 获取具体的文件格式后缀（png、jpeg、webp）
  const suffix = type.split("/")[1];
  // 使用atob()对base64数据进行解码  结果是一个文件数据流 以字符串的格式输出
  const bstr = window.atob(data[1]);
  // 获取解码结果字符串的长度
  let n = bstr.length;
  // 根据解码结果字符串的长度创建一个等长的整形数字数组
  // 但在创建时 所有元素初始值都为 0
  const u8arr = new Uint8Array(n);
  // 将整形数组的每个元素填充为解码结果字符串对应位置字符的UTF-16 编码单元
  while (n--) {
    // charCodeAt()：获取给定索引处字符对应的 UTF-16 代码单元
    u8arr[n] = bstr.charCodeAt(n);
  }
  let newFileName = fileName;
  if (!newFileName) {
    newFileName = new Date().getTime();
  }
  newFileName += `.${suffix}`;
  // 利用构造函数创建File文件对象
  // new File(bits, name, options)
  const file = new File([u8arr], newFileName, {
    type,
  });
  // 将File文件对象返回给方法的调用者
  return file;
}

export function convertSize(size) {
  if (size === 0) return "0 B";
  if (!size) return "";
  const units = ["B", "KB", "MB"];
  let i = 0;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }
  return size.toFixed(2) + " " + units[i];
}
export async function blobToBase64(blobUrl) {
  // #ifdef H5
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  // #endif
}

export function base64ToBlob(code) {
  // #ifdef H5
  const parts = code.split(";base64,");
  const contentType = parts[0].split(":")[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new window.Blob([uInt8Array], { type: contentType });
  // #endif
}

export function getExtenstionByUrl(url) {
  // 使用正则表达式提取文件扩展名
  var fileExtension = url.match(/\.([0-9a-z]+)(?:[?#]|$)/i);

  // fileExtension[1] 就是文件的扩展名，如果没有匹配到则为 undefined
  if (fileExtension && fileExtension[1]) {
    return fileExtension[1];
  } else {
    return "";
  }
}

export function downloadByALink(base64, name, extension = "") {
  const a = document.createElement("a"); // 生成一个a元素
  const event = new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window,
  }); // 创建一个单击事件
  const downloadName = name || formatTime();
  const suffix = extension
    ? `${extension.includes(".") ? extension : `.${extension}`}`
    : "";
  a.download = downloadName.replace(/[\s:]+/g, "-") + suffix; // 设置图片名称
  a.href = base64; // 将生成的URL设置为a.href属性
  a.dispatchEvent(event); // 触发a的单击事件
}

export function imgUrlToFile(url, limit) {
  // 加载图片
  const image = new Image();
  image.setAttribute("crossOrigin", "anonymous");
  image.src = url;
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  return new Promise((resolve) => {
    image.onload = async () => {
      const size = limit || 1024;
      const long = image.width > image.height ? image.width : image.height;
      let scale = 1;
      if (long > size) {
        scale = size / long;
      }
      const w = image.width * scale;
      const h = image.height * scale;
      canvas.width = w;
      canvas.height = h;
      ctx.drawImage(image, 0, 0, w, h);
      const canvasPath = canvas.toDataURL();
      const file = base64ToFile(canvasPath);
      resolve(file);
    };
    image.onerror = () => {
      resolve(null);
    };
  });
}

// 获取初始图片信息（宽、高等）
export const getImgInfo = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.onload = async () => {
      resolve({
        width: img.width,
        height: img.height,
      });
    };
    img.onerror = () => {
      reject({
        msg: "图片加载失败",
      });
    };
  });
};
